import { render, staticRenderFns } from "./MonetaryRewardSection.vue?vue&type=template&id=3cd9f972&scoped=true&"
import script from "./MonetaryRewardSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonetaryRewardSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonetaryRewardSection.vue?vue&type=style&index=0&id=3cd9f972&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd9f972",
  null
  
)

export default component.exports